import React from "react";
import { makeStyles } from "tss-react/mui";
import { Fade } from "react-awesome-reveal";
import eduImgWhite from "../../assets/svg/education/eduImgWhite.svg";
import "./Education.css";
import { connect } from "react-redux";

type IEducationCardProps = Partial<ReturnType<typeof mapStateToProps>> & {
  id;
  institution;
  course;
  startYear;
  endYear;
};

function EducationCard(props: IEducationCardProps) {
  const { theme, id, institution, course, startYear, endYear } = props;

  const useStyles = makeStyles()((t) => ({
    educationCard: {
      backgroundColor: "#ffffff",
      boxShadow: `0 6px 20px ${theme.primary30}`,
      transition: "box-shadow 200ms ease-in-out, transform 200ms ease-in-out",
      "&:hover": {
        boxShadow: `0 10px 28px ${theme.primary50}`,
        transform: "translateY(-2px)",
      },
    },
  }));

  const { classes } = useStyles();

  return (
    <Fade direction="up" triggerOnce>
      <div key={id} className={`education-card ${classes.educationCard}`}>
        <div className="educard-img" style={{ backgroundColor: theme.primary }}>
          <img src={eduImgWhite as unknown as string} alt="" />
        </div>
        <div className="education-details">
          <h6 style={{ color: theme.primary }}>
            {startYear}-{endYear}
          </h6>
          <h4 style={{ color: theme.tertiary }}>{course}</h4>
          <h5 style={{ color: theme.tertiary80 }}>{institution}</h5>
        </div>
      </div>
    </Fade>
  );
}

const mapStateToProps = (state) => ({
  theme: state.rootState.theme,
});

export default connect(mapStateToProps)(EducationCard);
